// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"165":"6ed1f3d9","824":"6ed1f3d9"}[chunkId] + ".chunk.css";
};